module.exports = {"530824101":"威远镇","530824102":"永平镇","530824103":"正兴镇","530824104":"民乐镇","530824105":"凤山镇","530824106":"景谷镇","530824201":"碧安乡","530824204":"益智乡","530824205":"半坡乡","530824206":"勐班乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530824.json
// module id = 2409
// module chunks = 0